import axios from "axios";

const KEY = "AIzaSyDFmAfJ5Cez9LwhD4B2hhS5kJ0bVV-ZBcQ";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    type: "video",
    maxResults: 5,
    key: `${KEY}`,
  },
});
